import React from "react";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { SERVICES_LIST } from "../data/company";

export function ServicesPage() {
  return (
    <div className="min-h-screen flex flex-col pt-28 pb-16 bg-[#f3f4f6]">
      <SEO
        title="Ydelser - Kokholm Byg"
        description="Kokholm Byg tilbyder professionelt murerarbejde i Holstebro, Herning, Viborg og Ringkøbing. Se vores ydelser inden for flisearbejde, badeværelser, reparationer, renovering, tilbygning og nybyggeri."
      />

      {/* Hero Banner */}
      <section 
        style={{ marginTop: '-40px' }}
        className="bg-[#1e2329] text-white py-14 border-b border-[#2d343f]"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="text-[#c06228] text-xs font-bold uppercase tracking-wider bg-[#272d36] px-3 py-1 rounded border border-[#373f4b]">
              Kvalitetsarbejde i Holstebro & Omegn
            </span>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mt-3 text-white">
              Vores ydelser
            </h1>
            <p className="text-gray-300 text-sm sm:text-base mt-2">
              Med mere end 30 års erfaring leverer Kokholm Byg solidt håndværk tilpasset dit behov.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-12 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {SERVICES_LIST.map((service) => (
              <div
                key={service.slug}
                className="bg-white border border-gray-200 rounded-lg p-8 shadow-sm hover:shadow-xl transition-all duration-200 flex flex-col justify-between"
              >
                <div>
                  <div className="w-14 h-14 bg-[#1e2329] text-[#c06228] rounded flex items-center justify-center text-2xl mb-6">
                    <i className={service.icon} aria-hidden="true" />
                  </div>

                  <h2 className="text-xl font-bold text-[#1e2329] mb-3">
                    {service.title}
                  </h2>

                  <p className="text-gray-600 text-sm leading-relaxed mb-6">
                    {service.shortDescription}
                  </p>
                </div>

                <div className="pt-4 border-t border-gray-100 flex items-center justify-between">
                  <Link
                    to={`/vi-tilbyder/${service.slug.replace('vi-tilbyder-', '')}`}
                    className="inline-flex items-center gap-2 font-semibold text-sm text-[#c06228] hover:text-[#aa521d] transition-colors"
                  >
                    <span>Læs mere og se galleri</span>
                    <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                  </Link>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Banner */}
          <div className="mt-16 bg-[#1e2329] text-white p-8 sm:p-12 rounded-lg border border-[#2d343f] flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="space-y-2">
              <h3 className="text-2xl font-bold text-white">Har du en specifik opgave i tankerne?</h3>
              <p className="text-gray-300 text-sm sm:text-base">
                Kontakt os for en professionel besigtigelse og en uforpligtende drøftelse af dit projekt.
              </p>
            </div>
            <Link
              to="/kontakt"
              className="btn-cta text-base font-semibold px-8 py-3.5 rounded shadow whitespace-nowrap"
            >
              Få et uforpligtende tilbud
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
